module.exports = __webpack_public_path__ + "img/kenji-fujimori.bba6ee71.png";